export interface ParsedTemplateRow {
  offsetDays: number;
  title: string;
}

/**
 * Wandelt kopierte Textzeilen in Vorlagenzeilen um. Neben reinem Text werden
 * die gebräuchlichen Formen „-2. Aufgabe“, „-2 | Aufgabe“ und Tabellenspalten
 * aus Excel unterstützt.
 */
export function parseTemplateRows(text: string, defaultOffsetDays = 0): ParsedTemplateRow[] {
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const withOffset = line.match(/^([+-]?\d+)\s*(?:\.|\||;|\t)\s*(.+)$/);
      if (!withOffset) return { offsetDays: defaultOffsetDays, title: line };
      return { offsetDays: Number(withOffset[1]), title: withOffset[2]!.trim() };
    });
}
